import React, { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Building2 } from "lucide-react";

const FIELDS = [
  { k: "company_name", l: "Company name", span: true },
  { k: "ein", l: "EIN number", ph: "XX-XXXXXXX" },
  { k: "contact_name", l: "Contact person" },
  { k: "email", l: "Email", type: "email" },
  { k: "phone", l: "Phone", type: "tel" },
  { k: "address", l: "Street address", span: true },
  { k: "city", l: "City" },
  { k: "state", l: "State", ph: "e.g. FL" },
  { k: "zip_code", l: "Zip code" },
];

export const CompanyProfileCard = ({ company, onSaved }) => {
  const [form, setForm] = useState(company);
  const [busy, setBusy] = useState(false);
  useEffect(() => { setForm(company); }, [company]);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const payload = Object.fromEntries(FIELDS.map((f) => [f.k, form[f.k] || ""]).filter(([k, v]) => !(k === "email" && !v)));
      const { data } = await api.put("/company/profile", payload);
      onSaved(data);
      toast.success("Company profile saved");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <form onSubmit={save} className="card-soft" data-testid="company-profile-card">
      <h2 className="font-heading text-xl text-[#1E3F33] mb-4 flex items-center gap-2"><Building2 className="w-4 h-4 text-[#2D6A4F]"/> Company profile</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {FIELDS.map((f) => (
          <div key={f.k} className={`min-w-0 ${f.span ? "sm:col-span-2" : ""}`}>
            <label className="label-soft">{f.l}</label>
            <input data-testid={`company-${f.k.replace("_", "-")}-input`} type={f.type || "text"} className="input-soft" placeholder={f.ph} value={form[f.k] || ""} onChange={(e) => setForm({ ...form, [f.k]: e.target.value })}/>
          </div>
        ))}
      </div>
      <button disabled={busy} data-testid="company-profile-save" className="btn-primary mt-4 w-full">{busy ? "Saving…" : "Save company profile"}</button>
    </form>
  );
};
